import { render, staticRenderFns } from "./CompanyTask.vue?vue&type=template&id=66913c75&scoped=true"
import script from "./CompanyTask.vue?vue&type=script&lang=js"
export * from "./CompanyTask.vue?vue&type=script&lang=js"
import style0 from "./CompanyTask.vue?vue&type=style&index=0&id=66913c75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66913c75",
  null
  
)

export default component.exports